// extracted by mini-css-extract-plugin
module.exports = {"container":"TwoColumnLayout_container__9kRaT","left":"TwoColumnLayout_left__jeyCB","right":"TwoColumnLayout_right__BqKA9"};